import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import { useMemo, useState } from "react";
import styles from "./HistoryDetails.module.scss";
import { createDefaultHistoryAccountDetailsView } from "./accounts/views/defaultHistoryAccountDetailsView";
import { createHistoryAccountDetailsViewConfig } from "./accounts/views/historyAccountDetailsViewConfig";
import { HistoryAccountTable } from "./accounts/utils/historyAccountDetailsRows";

interface HistoryAccountDetailsProps {
    table: HistoryAccountTable;
    emptyStateHeader: string;
    footer: React.ReactNode;
}

export const HistoryAccountDetails: React.FC<HistoryAccountDetailsProps> = ({
    table,
    emptyStateHeader,
    footer,
}) => {
    const [view, setView] = useState<View>(() =>
        createDefaultHistoryAccountDetailsView(table.kind),
    );
    const viewConfig = useMemo(
        () =>
            createHistoryAccountDetailsViewConfig({
                kind: table.kind,
                changedFieldLabel: table.changedFieldLabel,
            }),
        [table.kind, table.changedFieldLabel],
    );

    return (
        <ViewTable
            data={table.rows}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header={emptyStateHeader} />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
